"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardProjects = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const AdminMGTProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/admin/AdminMGTProvider");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const antd_1 = require("antd");
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const AdminDashboardProjects = () => {
    var _a;
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const [pagination] = (0, react_1.useState)({ hideOnSinglePage: false, defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "50", "100", "300"], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` });
    const tableColumns = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const tableColumns = [
            {
                title: "Name",
                render: (value, record) => record.meta.name,
                sorter: (a, b) => a.meta.name.localeCompare(b.meta.name),
            },
            {
                title: "Participants",
                render: (value, record) => record.meta.participantCount,
                sorter: (a, b) => a.meta.participantCount - b.meta.participantCount,
            },
            {
                title: "Created",
                render: (value, record) => {
                    const date = DateTimeUtils_1.DateTimeUtils.formatDate(record.meta.createdTimeSeconds * 1000, "dayTimeSeconds");
                    const ago = DateTimeUtils_1.DateTimeUtils.formatDate(record.meta.createdTimeSeconds * 1000, "ago", true);
                    return React.createElement(React.Fragment, null,
                        date,
                        React.createElement("br", null),
                        React.createElement("small", null, ago));
                },
                sorter: (a, b) => a.meta.createdTimeSeconds - b.meta.createdTimeSeconds,
                defaultSortOrder: "descend"
            },
            {
                title: "Keys",
                render: (value, record) => record.info.keyCount,
                sorter: (a, b) => a.info.keyCount - b.info.keyCount,
            },
            {
                title: "Text, Symbols",
                render: (value, record) => record.info.textLengthTotal,
                sorter: (a, b) => a.info.textLengthTotal - b.info.textLengthTotal,
            },
            {
                title: "Text, Memory",
                render: (value, record) => (0, AdminMGTProvider_1.formatToShortMemory)(record.info.textLengthTotal * 4),
                sorter: (a, b) => a.info.textLengthTotal - b.info.textLengthTotal,
            },
            {
                title: "Audit Log",
                render: (value, record) => record.info.auditLogSize,
                sorter: (a, b) => a.info.auditLogSize - b.info.auditLogSize,
            },
            {
                title: "UpdateId",
                render: (value, record) => record.info.lastUpdateId,
                sorter: (a, b) => a.info.lastUpdateId - b.info.lastUpdateId,
            },
            {
                title: "Last Change",
                render: (value, record) => {
                    const date = DateTimeUtils_1.DateTimeUtils.formatDate(record.info.lastChangeSeconds * 1000, "dayTimeSeconds");
                    const ago = DateTimeUtils_1.DateTimeUtils.formatDate(record.info.lastChangeSeconds * 1000, "ago", true);
                    return React.createElement(React.Fragment, null,
                        date,
                        React.createElement("br", null),
                        React.createElement("small", null, ago));
                },
                sorter: (a, b) => a.info.lastChangeSeconds - b.info.lastChangeSeconds,
            },
        ];
        return tableColumns;
    }, [], lodash_1.default.isEqual);
    const dataSource = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        var _a;
        return ((_a = adminMGTContext.mgtInfo.data) === null || _a === void 0 ? void 0 : _a.activeProjects) || [];
    }, [(_a = adminMGTContext.mgtInfo.data) === null || _a === void 0 ? void 0 : _a.activeProjects], lodash_1.default.isEqual);
    const { mgtInfo: { status: { inProgress } } } = adminMGTContext;
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.PageContent.CardSpacer, null),
        React.createElement(PageContent_1.PageContent.Card, null,
            React.createElement(antd_1.Table, { dataSource: dataSource, columns: tableColumns, rowKey: record => `${JSON.stringify(record)}`, loading: inProgress, size: "small", pagination: pagination })));
};
exports.AdminDashboardProjects = AdminDashboardProjects;
